export default __webpack_public_path__ + "static/media/cupcake-1.14016e31.jpeg";